// extracted by mini-css-extract-plugin
module.exports = {"previewBox":"Preview_previewBox__1lrWP","preview":"Preview_preview__2-s31"};